
import { defineComponent, ref } from "vue";
import { useLazySection } from "../composables/useLazySection";

export default defineComponent({
  name: "RetentionSection",
  props: {
    retention: { type: Object, required: true },
    loaded: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  emits: ["visible", "retry"],
  setup(props, { emit }) {
    const root = ref<HTMLElement | null>(null);
    useLazySection(root, () => emit("visible"));

    // d1Rate/d7Rate/d30Rate are null when the cohort hasn't aged enough for the
    // measurement to exist yet (e.g. every cohort from the last 30 days has
    // d30Rate === null). Render that as an em dash, never as "0.0%" — that would
    // read as total churn.
    const formatRate = (rate: number | null | undefined) =>
      rate === null || rate === undefined ? "—" : `${(rate * 100).toFixed(1)}%`;

    return { root, formatRate };
  },
});
